import styled from 'styled-components'



export const ListContainer = styled.div`
    position: relative;
`
